import { Service } from '@anispi-reporting-system/types';

const labels: {
  Service: { [key in Service]: string };
} = {
  Service: {
    'HOMECARE-RS': 'わおん訪看',
    'HOMECARE-RY': 'ファミリーナース',
    RS: 'わおん（介護包括型）',
    RY: 'ビーハック（日中支援型）',
    RYSHORT: 'ビーハック（短期入所）',
  },
};

export { labels };
